import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { SearchArchiveTabEntry } from "frontend/contentful/schema/primitives";
import { TabProps } from "design-system/components/primitives/tabs/tabs";
import { useContentful } from "frontend/hooks/use-contentful";
import {
  ArchiveContentEntry,
  BentoBoxEntry,
} from "frontend/contentful/schema/semantics";
import { BentoBox } from "design-system/sites/baker/bento-box/bento-box";
import { createBentoBoxProps } from "../semantics/bento-box.props";
import { createArchiveContentProps } from "../semantics/archive-content.props";
import { ArchivePageContent } from "design-system/components/search/archive-page-content/archive-page-content";

const isBentoBox = (
  content?: ArchiveContentEntry | BentoBoxEntry,
): content is BentoBoxEntry =>
  content !== undefined && "columns" in content.fields;
const isArchiveContent = (
  content?: ArchiveContentEntry | BentoBoxEntry,
): content is ArchiveContentEntry =>
  content !== undefined && "contentSource" in content.fields;

interface Options {
  order?: number;
}

export const createSearchArchiveTabProps = createContentfulProps<
  SearchArchiveTabEntry,
  TabProps,
  Options
>(({ entry, options, createEditAttributes }) => {
  const { getEntry } = useContentful();
  const content = getEntry(entry.fields.content);

  let tabContent = null;

  if (isBentoBox(content)) {
    const props = createBentoBoxProps(content, {
      tabTitle: entry.fields.title,
      headerAbove: true,
    });
    if (props) {
      tabContent = <BentoBox {...props} />;
    }
  } else if (isArchiveContent(content)) {
    const props = createArchiveContentProps(content, {
      slug: entry.fields.title
        ? "#" + entry.fields.title.replace(/[^A-Za-z0-9]/g, "")
        : undefined,
      headerAbove: true,
      order: options?.order,
    });
    if (props) {
      tabContent = <ArchivePageContent {...props} />;
    }
  }

  return {
    tabLabel: entry.fields.title || "",
    tabContent,

    editAttributes: {
      tabLabel: createEditAttributes({ entry, fieldId: "title" }),
    },
  } satisfies TabProps;
});
